module.exports = __webpack_public_path__ + "static/close-bdbef202aadf1505596cd4c0fb431446.png";